var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-header"},[_c('h2',[_vm._t("default",[_vm._v("Dashboard")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }